import { render } from "./EditProjectModal.vue?vue&type=template&id=af3e7682&scoped=true"
import script from "./EditProjectModal.vue?vue&type=script&lang=js"
export * from "./EditProjectModal.vue?vue&type=script&lang=js"

import "./EditProjectModal.vue?vue&type=style&index=0&id=af3e7682&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3e7682"]])

export default __exports__